import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../../lib/api";

const VISITOR_KEY = "leovera_visitor_id";

// Random, non-personal client-side token (not tied to any account) — only
// used to estimate distinct "active now" visitors in the admin stats.
const getVisitorId = () => {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
};

// Fires on every public-site route change (admin area excluded) — used only
// to compute aggregate, anonymous traffic stats for Admin > Statistiche visite.
const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;
    api.post("/page-views", { path, visitor_id: getVisitorId() }).catch(() => {});
  }, [location.pathname]);
  return null;
};

export default PageViewTracker;
